/**
 * Overwrite para bug do vs-select (Vuesax):
 * - Quando o usuário clica e segura, o select abre no focus
 * - Ao soltar o mouse, o click global fecha imediatamente
 * - Interceptamos o click em capture se ele começou dentro do select
 */
export default class VsSelectOverwriteHandler {
    constructor(options = { }) {
        this.selectRootClass = options.selectRootClass || '.con-select';
        this.optionsSelector = options.optionsSelector || '.vs-select--options:not([style*="display: none"])';

        this.mouseDownInside = false;
        this.installed       = false;

        this.__onMouseDown    = this.__onMouseDown.bind(this);
        this.__onClickCapture = this.__onClickCapture.bind(this);
    }

    __install() {
        if (this.installed) return

        document.addEventListener('mousedown', this.__onMouseDown, true);
        document.addEventListener('click', this.__onClickCapture, true);
        this.installed = true;
    }

    __destroy() {
        if (!this.installed) return;

        document.removeEventListener('mousedown', this.__onMouseDown, true);
        document.removeEventListener('click', this.__onClickCapture, true);
        this.installed = false;
    }

    __onMouseDown(event) {
        this.mouseDownInside = !!event.target.closest(this.selectRootClass);
    }

    __onClickCapture(event) {
        if (!this.mouseDownInside) return;

        const isVsSelectOpen = document.querySelector(this.optionsSelector);
        if (!isVsSelectOpen) return;

        event.stopImmediatePropagation();
        this.mouseDownInside = false;
    }
}